<div class="lang btn-action">
  <img src="assets/icons/global.svg" alt="language" />

  <div class="lang-list">
    <span
      (click)="langChange('ar')"
      [class.active]="currentLang === 'ar'"
      tabindex="7">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="16"
        width="14"
        viewBox="0 0 448 512"
        fill="white">
        <path
          d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
      </svg>
      العربية
    </span>
    <span
      (click)="langChange('en')"
      [class.active]="currentLang === 'en'"
      tabindex="8">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="16"
        width="14"
        viewBox="0 0 448 512"
        fill="white">
        <path
          d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
      </svg>
      English
    </span>
  </div>
</div>
